import React from "react";
import { useEffect, useState } from "react";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import Carousel from "react-material-ui-carousel";
import ContentCards from "../components/homepage/contentCards";
import CustomizedAccordions from "../components/homepage/accordion";
import CustomContainer from "../components/layout/container";
import CustomHeader from "../components/layout/header";

import howCoinsNotes from "../images/Coins_Notes_Narrow.jpg"
import howTradeExch from "../images/TradingExchangeBlue.jpg"
import howriskNZpie from "../images/riskNZghgPieLineCht.jpg"
import howDataCentre from "../images/DataCentreBlue_Original.jpg"
// import howSoldiers from "../images/Soldiers_OrangeSky.jpg"
import howSoldiers from "../images/Soldiers_OrangeSkyHalf.jpg"
import stuInflows from "../images/OverseasStudentsUK_305_83.jpg"


const carouselHeight = "150px";
const How = () => {
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [links, setLinks] = useState("");
  const { howSubPage } = useParams();

  const router = useNavigate();
  const [pageTitle, setPageTitle] = useState("");
  const [borderColorToHighlight, setborderColorToHighlight] = useState("");

  const getRouterData = () => {
    if (howSubPage) {
      const url = howSubPage.replace(/-/g, " ");
      setLinks(url);
      const finalString = url
        .split(" ")
        .map((word, index) =>
          index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
        )
        .join(" ");
      setPageTitle(finalString);
      setTimeout(() => {
        setborderColorToHighlight(theme.palette.primary.dark);
      }, 100);
    }
  };

  const breadcrumbData = [
    {
      name: "Home",
      link: "/",
    },
    {
      name: `How (${pageTitle})`,
      link: `/how/${howSubPage}`,
    },
  ];

  useEffect(() => {
    getRouterData();
  }, [howSubPage]);

  return (
    <Box>
      <Grid>
        <title>{pageTitle?.toUpperCase()} | MEF</title>
        <meta
          name="description"
          content="Identify & Quantify Macroeconomic/Esg risk"
        />
      </Grid>
      <CustomHeader
        title={`How? <span style="font-size:1.2rem; color:rgba(84,77,160,1);"> - MEF Global Models & Apps</span>`}
        breadcrumbData={breadcrumbData}
      />

      <CustomContainer>
        <Box >
      <Typography variant="body1" color="rgba(84,77,160,1)" sx={{ mb: 2 }}>
      MEF's foundational Global model is mGEM, but it is complimented by a number of more specialist add-on modules. From these, MEF can then
      build/estimate client models that transmit Global "drivers" into the domain/market areas of SMEs for more fine-grain scenario analysis.   </Typography>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6} md={2.4}>
              <ContentCards
                imgSrc={howCoinsNotes}
                title="mGEM-Global Macroeconomic Model"
                objectFit="fill"
                subTitle="Explore 'Known-Unknowns' Macro Risks"
                borderColor={
                  links == "mGEM global macro"
                    ? borderColorToHighlight
                    : "none"
                }

                body={`MEF's core model is <a title="macro Global Econometric Model">mGEM</a> but it has been extended with specialist add-on modules for <b>Industrial Sectors</b> (iGEM),
                Energy Use/Generation (enGEM), GHG emissions (eGEM) and Portfolio returns/Esg (finGEM) and Global Liquidity(gliGEM). Some users will be only interested in quantifying (Global)
                macroeconomic risks but the add-on modules allow this to extend to scenario analysis across Industry-mix, Energy, GHG Emissions and Finance/Liquidity flows. `}
              />
              <CustomizedAccordions
                title="Country Coverage - mGEM Macro Model"
                body={`
                <table>
                <tbody style="font-size: 12px; color: rgba(84,77,160,1) ;";>
                <tr style="background-color: rgba(84,77,160,.1);">
                  <th><strong>Zone</strong></th> <th><strong>Coverage</strong></th>
                </tr>
                <tr>
                  <td><strong>G7</strong></td> <td>US, Japan, Germany, France, Italy, Canada, <b>UK</b></td>
                </tr>
                <tr style="background-color: rgba(84,77,160,.1);">
                  <td><strong>Other OECD</strong></td> <td>Australia, Austria, Belgium, Chile, [Colombia], [Costa Rica], Czech Republic, Denmark, Estonia, Finland, Greece, Holland, Hungary,
                  Iceland, Ireland, Israel, Korea, [Latvia], [Lithuania], Luxembourg, Mexico, N Zealand, Norway, Poland, Portugal, Slovakia, Slovenia,
                  Spain, Sweden, Switzerland
                  </td>
                </tr>
                <tr>
                  <td><strong>BRICS+</strong></td> <td>Brazil, Russia, India, China, South Africa, Argentina</td>
                </tr>
                <tr style="background-color: rgba(84,77,160,.1);">
                  <td><strong>Non-OECD</strong></td> <td>Saudi Arabia, [Bulgaria], [Croatia], [Peru], [Romania]</td>
                </tr>
                <tr >
                  <td><strong>Dynamic Asia</strong></td> <td>Thailand, Singapore, Malaysia, Taiwan, H.Kong SAR, Indonesia, Philippines, Viet Nam</td>
                </tr>
                <tr style="background-color: rgba(84,77,160,.1);">
                  <td><strong>Trade zones</strong></td> <td>Eastern/Central Europe, Africa & Middle East,Latin America, ROW</td>
                </tr>
                </table>
                                `}
              />
              <CustomizedAccordions
                title="Global Linkages - mGEM Macro Model"
                body={`  The "connectedness" of a global economic model determines the extent of spillovers of national
                economic/policy "shocks".The various international "transmission mechanisms" in mGEM include: <br><br>
                <table>
                <tbody style="font-size: 12px; color: rgba(84,77,160,1) ;";>
                <tr style="background-color: rgba(84,77,160,.1);">
                  <th><strong>Type</strong></th> <th><strong>Linkage Detail</strong></th>
                </tr>
                <tr>
                  <td><b>Trade</b></td> <td>53 Country/Zone Trade Matrix(Goods & Services)</td>
                </tr>
                <tr style="background-color: rgba(84,77,160,.1);">
                  <td><b>Financial</b> </td> <td>Benchmark Bond Yields - US/Global Drivers</td>
                </tr>
                <tr>
                  <td><b>Liquidity</b></td> <td>Impacts "Risk-On" Assets (Equity, Property)</td>
                </tr>
                      <!--tr style="background-color: rgba(0, 160, 160,.1);">
                        <td>Other1</td> <td>[TBA]</td>
                      </tr>
                      <tr>
                        <td>Other2</td> <td>[TBA]</td>
                      </tr-->
                </table>
                                `}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <ContentCards
                imgSrc={howTradeExch}
                title="finGEM-Global Finance/Liquidity Model"
                subTitle="Explore & Quantify Portfolio/ESG Risks"
                borderColor={
                  links == "finGEM global finance"
                    ? borderColorToHighlight
                    : "none"
                }
                body={`Global liquidity is a key driver of national economic activity, credit availability & asset prices - it will often amplify national business cycles. Using <a title="finance Global Econometric Model">finGEM</a> we are able
                to explore Financial-Macroeconomic- linkages via macro scenario analysis & capture the effects on typical <b>investment Portfolios</b> (eg 60:40-Equity:Bonds) `}
              />
              <CustomizedAccordions
                title="Macro-Financial Linkages"
                body={`(Global) credit flows and refinancing flows are crucial to the operation of a modern macroeconomy, particularly given the inexorable rise in global debt levels since the 1980s.
                Equally, the macro growth prospects of national economies are crucial for the investor/creditor confidence in debt sustainability & solvency concerns.
                Given the legacy of the <a title="Global Financial Crisis 2007/08">GFC </a> its essential for prudential investors & wealth managers to be aware of risks
                in either domain.`}
              //                body="Each quarter, MEF produces several pre-configured scenarios (see previous examples) which cover significant current areas of macro risk at both Global and/or UK levels."
              />
              <CustomizedAccordions
                title="Global Liquidity Drivers"
                body={`Fund Managers can explore/quantify potential fund risk from key national/global macro & environmental/Esg risks & threats via the Portfolio interrogation form to generate a dynamic, Esg rating to 2050.
                MEF can also conduct "GreenTech shocks" to explore technology (eg CCS) and policy (Carbon price) shocks impacting trajectories toward net zero carbon & related winners/losers. `}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <ContentCards
                imgSrc={howriskNZpie}
                title="eGEM-Global GHG Emissions Model"
                objectFit="contain"
                subTitle="Quantify Industry/Sector Emissions"
                borderColor={
                  links == "eGEM global emissions"
                    ? borderColorToHighlight
                    : "none"
                }
                body={`Combining the Global Industry sector model <a title="industry Global Econometric Model">iGEM</a> and global emissions
                module <a title="emissions Global Econometric Model">eGEM</a> allows MEF to model <b>"bottom-up" GHG emissions</b> that account for the
                industry-mix of output - thereby, more precisely capturing the environmental impacts of global macro/tech shocks. Deviations of
                individual firms from Industry Sector Carbon Intensity budgets can also be identified as well as possible shifts in those sectoral budgets
                as global economic scenarios are war-gamed.`}
              />
              <CustomizedAccordions
                title="Industry-Emissions Linkages"
                body={`The iGEM model allows the feed-through of mGEM global/national shocks to <b>12 industrial sectors</b> (ISIC Rev. 4) across most/all of the major economies covered by mGEM.
                This in turn can then generate a <b>"bottom-up" derivation of National emissions</b> from national industrial sectors using the eGEM emissions model.
                Energy producing Nations (Australia, Canada, US) will tend to have higher onshore emissions than "offshoring" piers.`}
              />
              <CustomizedAccordions title="Industrial Sector Coverage - iGEM Model"
                body={`
              <table>
              <tbody style="font-size: 12px; color: rgba(84,77,160,1); text-align: left;";>
              <tr style="background-color: rgba(84,77,160,.1);">
              <th><strong>iGEM Coverage: ISIC4 Industrial Sectors</strong></th>
              </tr>
              <tr><td> Agriculture, forestry and fishing</tr></td>
              <tr style="background-color: rgba(84,77,160,.1);"><td> Energy</tr></td>
              <tr><td> Manufacturing</tr></td>
              <tr style="background-color: rgba(84,77,160,.1);"><td> Construction</tr></td>
              <tr><td> Services - of which:</tr></td>
              <tr style="background-color: rgba(84,77,160,.1); text-align: center;"><td>Distribution trade, repairs; transp.; accommodation., food service activities</tr></td>
              <tr style="text-align: center;" ><td>Information and communication</tr></td>
              <tr style="background-color: rgba(84,77,160,.1); text-align: center;"><td>Financial and insurance activities</tr></td>
              <tr style="text-align: center;"><td>Real estate activities</tr></td>
              <tr style="background-color: rgba(84,77,160,.1); text-align: center;"><td>Prof., scientific, technical activities; admin., support service activities.</tr></td>
              <tr style="text-align: center;"><td>Public admin.; compulsory s.s.; education; human health</tr></td>
              <tr style="background-color: rgba(84,77,160,.1); text-align: center;"><td>Other service activities</tr></td>
             </table>  `}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <ContentCards
                imgSrc={howDataCentre}
                title="enGEM-Global Energy Model"
                subTitle="Explore Energy Demand/Supply; enGEM"
                borderColor={
                  links == "enGEM global energy"
                    ? borderColorToHighlight
                    : "none"
                }
                body={`Energy is the key input to economic activity and enGEM allows MEF to examine the balance of <b>Energy Use across 4 sectors</b> & (Electricity) <b>Generation by 9 fuel types</b> - at both a national & Regional/Global level.
                Crucial for meeting 2050 emissions targets are: (i) <i>wider</i> Electricity usage (ii) <i>cleaner</i> Electricity generation. MEF can impose official
                forecasts for Energy Use and Generation to 2050 as a baseline and then investigate deviations/risks in these projections due to (Global) macroeconomic or GreenTech shocks.`}
              />
              <CustomizedAccordions
                title="Energy Use/Generation by Sector - enGEM Model"
                body={`
                <table>
                <tbody style="font-size: 12px; color: rgba(0, 160, 160,1);text-align: center;";>
                <tr style="background-color: rgba(0, 160, 160,.1);">
                  <th><strong>Energy Use Sector</strong></th><th>&nbsp;&nbsp;&nbsp; </th> <th><strong>Electricity Generation by Fuel..</strong></th><th><strong>..of which: Renewables</strong></th>
                </tr>
                <tr>
                  <td>Residential</td><td>&nbsp;&nbsp;&nbsp;</td> <td>Liquid/Oil</td><td>Wind</td>
                </tr>
                <tr style="background-color: rgba(0, 160, 160,.1);">
                  <td>Industrial</td><td>&nbsp;&nbsp;&nbsp;</td> <td>Coal</td><td>Solar</td>
                </tr>
                <tr>
                  <td>Commercial</td><td>&nbsp;&nbsp;&nbsp;</td> <td>Natural Gas</td><td>Geothermal</td>
                </tr>
                <tr style="background-color: rgba(0, 160, 160,.1);">
                  <td>Transport</td><td>&nbsp;&nbsp;&nbsp;</td> <td>Nuclear</td><td>Hydro</td>
                </tr>
                <tr>
                  <td></td><td>&nbsp;&nbsp;&nbsp;</td> <td>[Renewables]..</td><td>Other</td>
                </tr>
                </table>`}
              />
              <CustomizedAccordions
                title="Countries/Zones Covered - enGEM Model"
                body={`
                <table>
                <tbody style="font-size: 12px; color: rgba(0, 160, 160,1);text-align: center;";>
                <tr style="background-color: rgba(0, 160, 160,.1);">
                  <th><strong>Country           </strong></th> <th><strong>Region</strong></th>
                </tr>
                <tr>
                  <td>US</td> <td>Australia/New Zealand</td>
                </tr>
                <tr style="background-color: rgba(0, 160, 160,.1);">
                  <td>Canada</td> <td>Europe</td>
                </tr>
                <tr>
                  <td>Mexico</td> <td>Non-OECD Europe/Eurasia</td>
                </tr>
                <tr style="background-color: rgba(0, 160, 160,.1);">
                  <td>Brazil</td> <td>Other Non-OECD Asia</td>
                </tr>
                <tr>
                  <td>Japan</td> <td>Other Central/South America</td>
                </tr>
                <tr style="background-color: rgba(0, 160, 160,.1);">
                  <td>South Korea</td> <td>Middle East</td>
                </tr>
                <tr>
                  <td>China</td> <td>Africa</td>
                </tr>
                <tr style="background-color: rgba(0, 160, 160,.1);">
                  <td>India</td> <td>World</td>
                </tr>
                <tr>
                  <td>Russia</td> <td></td>
                </tr>
                </table>
                `}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
             <ContentCards
                imgSrc={howSoldiers}
                title="defGEM-Global Defence Spending Model"
                subTitle="Explore Factors Influencing MILEX"
                borderColor={
                  links == "defGEM global defence"
                    ? borderColorToHighlight
                    : "none"
                }
                imageHeight={80}  // Add this prop only for howSoldiers
                body={`Higher Defence spending ("MILEX") demands - with geo-politically instability - is constrained by the rising Fiscal burden of aging populations and rising National Debt burdens. <strong>32 NATO members</strong> are covered in defGEM (excl. Iceland) including Sweden & Finland with <strong>11 Non-NATO</strong> countries included; 
                total MILEX is disaggregated into <i>Equipment/R&D, Infrastructure, Personnel & Other.</i> `}
              />
              <CustomizedAccordions
                title="Non-NATO Countries-defGEM"
                body={`
                <table>
                <tbody style="font-size: 12px; color: rgba(0, 160, 160,1);text-align: center;";>
                <tr style="background-color: rgba(0, 160, 160,.1);">
                  <th><strong>Country:</strong></th> <th><strong>Alignment:</strong></th>
                </tr>
                <tr>
                  <td>Australia</td> <td>NATO</td>
                </tr>
                <tr style="background-color: rgba(0, 160, 160,.1);">
                  <td>Brazil</td> <td>Non-Aligned</td>
                </tr>
                <tr>
                  <td>China</td> <td>Non-Aligned/Russian pact</td>
                </tr>
                <tr style="background-color: rgba(0, 160, 160,.1);">
                  <td>India</td> <td>Non-Aligned</td>
                </tr>
                <tr>
                  <td>Japan</td> <td>NATO</td>
                </tr>
                <tr style="background-color: rgba(0, 160, 160,.1);">
                  <td>Russia</td> <td>Anti-NATO</td>
                </tr>
                <tr>
                  <td>Saudi Arabia</td> <td>Non-Aligned</td>
                </tr>
                <tr style="background-color: rgba(0, 160, 160,.1);">
                  <td>South Africa</td> <td>Non-Aligned</td>
                </tr>
                <tr>
                  <td>South Korea</td> <td>NATO</td>
                </tr>
                <tr style="background-color: rgba(0, 160, 160,.1);">
                  <td>Israel</td> <td>Non-Aligned</td>
                </tr>
                <tr>
                  <td>Indonesia</td> <td>Non-Aligned</td>
                </tr>
                </table>
                `}
              />
              <ContentCards
                imgSrc={stuInflows}
                title="stuGEM-Global Student Flows to UK"
                subTitle="Explore Risks to UK Student Inflows"
                borderColor={
                  links == "stuGEM global sudents"
                    ? borderColorToHighlight
                    : "none"
                }
                imageHeight={80}  // Add this prop only for howSoldiers
                body={`Inflows of International students to the UK has been suffered significantly post-COVID, most notably <b>Chinese
                  students</b> as the Chinese post-pandemic recovery - and thus demand for overseas education - is burdened by the ongoing Chinese property bust and
                  deflationary impetus. `}
              />
              <CustomizedAccordions
                title="stuGEM Country/Zone Coverage"
                body={`
 <table style="border-collapse: collapse; width: 100%; margin: 0px 0;">
  <style>
    .tbl th, .tbl td {
      border: 1px solid #ddd;
      padding: 2px;
      text-align: center;
      vertical-align: top;
      font-size: 0.8em;
      color: rgba(0, 160, 160, 1);
    }
    .tbl th {
      font-weight: bold;
      font-size: 0.92em;
      background-color: rgba(0, 160, 160, 0.4);
    }
    .tbl tr.alt {
      background-color: rgba(0, 160, 160, 0.1);
    }
    .tbl th[colspan="3"] {
      text-align: center;
    }
  </style>
  <thead class="tbl">
    <tr>
      <th colspan="3">-- HESA Country Coverage -- </th>
      <th>Region</th>
    </tr>
  </thead>
  <tbody class="tbl">
    <tr>
      <td>Argentina</td>
      <td>Portugal</td>
      <td>Poland</td>
      <td>Africa</td>
    </tr>
    <tr class="alt">
      <td>Australia</td>
      <td>India</td>
      <td>Romania</td>
      <td>Asia</td>
    </tr>
    <tr>
      <td>Austria</td>
      <td>Indonesia</td>
      <td>Russia</td>
      <td>Australasia</td>
    </tr>
    <tr class="alt">
      <td>Belgium</td>
      <td>Ireland</td>
      <td>S.Arabia</td>
      <td>EU</td>
    </tr>
    <tr>
      <td>Brazil</td>
      <td>Israel</td>
      <td>Singapore</td>
      <td>M. East</td>
    </tr>
    <tr class="alt">
      <td>Canada</td>
      <td>Italy</td>
      <td>Slovakia</td>
      <td>N. America</td>
    </tr>
    <tr>
      <td>Chile</td>
      <td>Japan</td>
      <td>Slovenia</td>
      <td>Europe</td>
    </tr>
    <tr class="alt">
      <td>China</td>
      <td>S.Korea</td>
      <td>S.Africa</td>
      <td>S. America</td>
    </tr>
    <tr>
      <td>Czechia</td>
      <td>Lux'brg</td>
      <td>Spain</td>
      <td></td>
    </tr>
    <tr class="alt">
      <td>Denmark</td>
      <td>Malaysia</td>
      <td>Sweden</td>
      <td></td>
    </tr>
    <tr>
      <td>Estonia</td>
      <td>Mexico</td>
      <td>Switzerland</td>
      <td></td>
    </tr>
    <tr class="alt">
      <td>Finland</td>
      <td>Netherlands</td>
      <td>Taiwan</td>
      <td></td>
    </tr>
    <tr>
      <td>France</td>
      <td>Nigeria</td>
      <td>Thailand</td>
      <td></td>
    </tr>
    <tr class="alt">
      <td>Germany</td>
      <td>N.Zealand</td>
      <td>Turkey</td>
      <td></td>
    </tr>
    <tr>
      <td>Greece</td>
      <td>N.Macedonia</td>
      <td>UAE</td>
      <td></td>
    </tr>
    <tr class="alt">
      <td>H.Kong</td>
      <td>Norway</td>
      <td>US</td>
      <td></td>
    </tr>
    <tr>
      <td>Hungary</td>
      <td>Philippines</td>
      <td>Vietnam</td>
      <td></td>
    </tr>
    <tr class="alt">
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
  </tbody>
</table>

                  `}
              />
            </Grid>
          </Grid>
        </Box>
      </CustomContainer>
    </Box>
  );
};

export default How;

// Mobile Apps and Webtools - powered by Global models/data
